import type { AuthUser } from "../../types/auth";
import ChatLayout from "../../features/chat/ChatLayout";

type ChatRouteProps = {
  token: string;
  user: AuthUser | null;
  onTokenChange: (token: string | null) => void;
  onOpenProfile: (targetId: string) => void;
  onDismissProfileRoute?: () => void;
  onOpenSettings: (section?: string) => void;
  onDismissSettingsRoute?: () => void;
};

// Thin wrapper so routing remains stable while ChatLayout evolves.
export default function ChatRoute(props: ChatRouteProps) {
  return <ChatLayout {...props} />;
}
